<template>
  <v-app>
    <router-view />
    <qz-snackbar />
    <qz-confirm />
  </v-app>
</template>

<script>
import QzSnackbar from '@/components/QzSnackbar.vue';
import QzConfirm from '@/components/QzConfirm.vue';

export default {
  name: 'app',
  inject: ['config'],
  components: {
    QzSnackbar,
    QzConfirm,
  },
  metaInfo() {
    const { primary: primaryColor } = this.config.partnerTheme;
    let faviconUrl;

    if (this.config.partnerNameFavicon.indexOf('http') === 0) {
      faviconUrl = this.config.partnerNameFavicon;
    } else {
      faviconUrl = `/retrieve-area-ui/${this.config.partnerNameFavicon}`;
    }

    const meta = [
      {
        name: 'theme-color',
        content: primaryColor,
      },
      {
        name: 'msapplication-TileColor',
        content: primaryColor,
      },
    ];

    const link = [
      {
        rel: 'icon',
        type: 'image/x-icon',
        href: faviconUrl,
      },
    ];

    return {
      title: 'Welcome to Your Personal Quote Center',
      meta,
      link,
    };
  },
};
</script>
